// getters
const cafeteriaEnlistment = state => state.cafeteriaEnlistment

export default {
  cafeteriaEnlistment
}



// WEBPACK FOOTER //
// ./src/store/modules/cafeteria/enlistment/getters.js